// @core/api/endpoints/analytics/update_widget.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateWidgetRequest,
  WidgetResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Update widget
 * Updates a widget's configuration, data source, or display options.
 */
export async function UpdateWidget(
  widget_id: string,
  data: UpdateWidgetRequest,
  options?: RequestOptions
): Promise<WidgetResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/widgets/:widget_id`;
  requestPath = requestPath.replace(':widget_id', encodeURIComponent(widget_id));
  const requestOptions = options;
  return client.put<WidgetResponse>(requestPath, data, requestOptions);
}
